const e = "cmp", n = otto[e], {
  allowAll: t,
  rejectAll: o,
  togglePreferenceCenter: s,
  resurfaceBanner: r,
  rejectGeneralVendorConsent: c,
  getConsentForGV: C,
  getConsentsForAllGVs: g,
  getIabConsentString: a,
  readVendorsConsents: l,
  archiveReceipt: p,
  emitConsentChangeEvent: A,
  getOttoOwnPurposesConsent: d,
  getAppGoogleTrackingConsent: i,
  getAdjustTrackingConsent: V,
  processAppConsentV2: u,
  consentChanged: E,
  onetrustLoaded: G
} = otto[e];
export {
  e as NEXUS_CMP_NAMESPACE,
  t as allowAll,
  p as archiveReceipt,
  n as cmp,
  E as consentChanged,
  A as emitConsentChangeEvent,
  V as getAdjustTrackingConsent,
  i as getAppGoogleTrackingConsent,
  C as getConsentForGV,
  g as getConsentsForAllGVs,
  a as getIabConsentString,
  d as getOttoOwnPurposesConsent,
  G as onetrustLoaded,
  u as processAppConsentV2,
  l as readVendorsConsents,
  o as rejectAll,
  c as rejectGeneralVendorConsent,
  r as resurfaceBanner,
  s as togglePreferenceCenter
};
